import { render, staticRenderFns } from "./ForwardTimelineItem.vue?vue&type=template&id=e369c5b2&scoped=true&"
import script from "./ForwardTimelineItem.vue?vue&type=script&lang=js&"
export * from "./ForwardTimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./ForwardTimelineItem.vue?vue&type=style&index=0&id=e369c5b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e369c5b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VChip,VDivider,VIcon})
